export default __webpack_public_path__ + "f2f9cef7262af446cf70c078edbd9b2c.png";